import axios from "axios";
const baseUrl = process.env.REACT_APP_BASE_URL;

export const fetchOrdersWithDetails = async (user_id, access_token) => {
  try {
    // 1. First fetch all orders for the user
    const ordersResponse = await axios.get(
      `${baseUrl}/orders/filter?user_id=${user_id}`,
      {
        params: { schema: "public" },
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );
    const orders = Array.isArray(ordersResponse.data) ? ordersResponse.data : [ordersResponse.data];

    if (orders.length === 0) return [];

    // 2. Fetch all cart items for all orders in one call
    const cartIds = orders.map(order => order.cart_id);
    const cartItemsPromises = cartIds.map(cart_id => 
      axios.get(
        `${baseUrl}/cart_items/filter_by_user_id_cart_id?cart_id=${cart_id}&user_id=${user_id}`,
        {
          params: { schema: "public" },
          headers: { Authorization: `Bearer ${access_token}` },
        }
      )
    );
    const cartItemsResponses = await Promise.all(cartItemsPromises);
    
    // Create a map of cart_id to cart items
    const cartItemsMap = cartItemsResponses.reduce((acc, response, index) => {
      const cartId = cartIds[index];
      acc[cartId] = Array.isArray(response.data) ? response.data : [response.data];
      return acc;
    }, {});

    // 3. Get unique product IDs from all cart items
    const allProductIds = new Set();
    Object.values(cartItemsMap).forEach(cartItems => {
      cartItems.forEach(item => allProductIds.add(item.product_id));
    });

    // 4. Fetch all product details in one batch
    const productDetailsPromises = [...allProductIds].map(productId =>
      axios.get(`${baseUrl}/products/${productId}`, {
        params: { schema: "public" },
        headers: { Authorization: `Bearer ${access_token}` },
      })
    );
    const productResponses = await Promise.all(productDetailsPromises);
    
    // Create a map of product details
    const productDetailsMap = productResponses.reduce((acc, response) => {
      acc[response.data.id] = response.data;
      return acc;
    }, {});

    // 5. Combine all data
    return orders.map(order => ({
      ...order,
      products: cartItemsMap[order.cart_id].map(cartItem => ({
        ...cartItem,
        productDetails: productDetailsMap[cartItem.product_id]
      }))
    }));

  } catch (error) {
    console.error("Error fetching orders with details:", error);
    throw error;
  }
}; 